import { Validators } from '@angular/forms';
import {
  PregnancyType,
  ValidationPair,
} from '@app/modules/service-data/types/service-data.types';
import { ivfGestationAgeValidator } from '@app/modules/service-data/validators/ivf-gestation-age.validator';
import { recentPregnancyValidator } from '@app/modules/service-data/validators/recent-pregnancy.validator';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';
import { errorValueValidator } from '@shared/validators/error-value-validator';

const NAME_PATTERN = /^(?!.*[\\/:*?"<>|]).*$/;

export const nipptValidationSet: ValidationPair = {
  children: {
    nippt: {
      children: {
        allegedFather: {
          children: {
            firstName: {
              validators: [
                Validators.required,
                Validators.pattern(NAME_PATTERN),
              ],
            },
            lastName: {
              validators: [
                Validators.required,
                Validators.pattern(NAME_PATTERN),
              ],
            },
            dateOfBirth: {
              validators: [Validators.required],
            },
            email: {
              validators: [Validators.required, Validators.email],
            },
            ethnicity: {
              validators: [Validators.required],
            },
            ethnicitySelect: {
              validators: [Validators.required],
            },
          },
        },
        patientHistory: {
          children: {
            anyReceivedStemCell: {
              validators: [Validators.required, errorValueValidator(true)],
            },
            anyReceivedBloodTransfusion: {
              validators: [Validators.required, errorValueValidator(true)],
            },
          },
          validators: [
            crossFieldValidator(
              'anotherPregnancy.type',
              'anotherPregnancy.wasPregnant',
              true
            ),
            crossFieldValidator(
              'anotherPregnancy.date',
              'anotherPregnancy.wasPregnant',
              true
            ),
          ],
        },
      },
    },
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientInformation: {
          children: {
            ethnicity: {
              validators: [Validators.required],
            },
            ethnicitySelect: {
              validators: [Validators.required],
            },
          },
        },
        currentPregnancyInformation: {
          children: {
            expectedConfinementDate: {
              validators: [Validators.required],
            },
            gestationAge: {
              children: {
                week: {
                  validators: [
                    Validators.required,
                    Validators.min(7),
                    Validators.max(40),
                  ],
                },
                day: {
                  validators: [
                    Validators.required,
                    Validators.min(0),
                    Validators.max(6),
                  ],
                },
              },
            },
            isGestationAgeAutomaticallyCalculated: {
              validators: [Validators.required],
            },
            pregnancyType: {
              validators: [Validators.required],
            },
            inVitro: {
              children: {
                isInVitroFertilized: {
                  validators: [Validators.required],
                },
              },
            },
          },
        },
      },
      validators: [
        ivfGestationAgeValidator(13),
        crossFieldValidator(
          'currentPregnancyInformation.chorionicityType',
          'currentPregnancyInformation.pregnancyType',
          PregnancyType.twins
        ),
        crossFieldValidator(
          'currentPregnancyInformation.inVitro.isSurrogateMother',
          'currentPregnancyInformation.inVitro.isInVitroFertilized',
          true
        ),
        crossFieldValidator(
          'currentPregnancyInformation.inVitro.vitroType',
          'currentPregnancyInformation.inVitro.isInVitroFertilized',
          true
        ),
      ],
    },
  },
  validators: [recentPregnancyValidator()],
};
